module.exports = new __parcel__URL__("a-kind-of-magic.66f7ec29.jpg").toString();